import { Box } from "@mui/material";
import { PaymentCommentStream } from "components/PaymentCommentStream";
import { PaymentComment } from "generated-graphql/graphql";

interface CommentsSectionProps {
  paymentId?: string;
  existingPayment?: any;
  currentUserId?: string;
  onCommentAdded?: (newComment: PaymentComment) => void;
  onCommentDeleted?: (deletedCommentId: string) => void;
}

export function CommentsSection({
  paymentId,
  existingPayment,
  currentUserId,
  onCommentAdded,
  onCommentDeleted,
}: CommentsSectionProps) {
  if (!paymentId || !existingPayment) {
    return null;
  }

  return (
    <Box>
      <PaymentCommentStream
        paymentId={paymentId}
        comments={existingPayment?.comments || []}
        currentUserId={currentUserId}
        onCommentAdded={(newComment) => {
          // Comments update automatically via Apollo cache
          onCommentAdded?.(newComment);
        }}
        onCommentDeleted={(deletedCommentId) => {
          // Comments update automatically via Apollo cache
          onCommentDeleted?.(deletedCommentId);
        }}
      />
    </Box>
  );
}
